import Action from '../../Action'
import './styles/ModalDeleteUSer.css'
import { useEffect, useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalDeleteUSer =({languaje,mode,buscar_cis,user,closDeleteUserModal,setData,setLoading,setError,server})=>{
    const [loadingM,setLoadingM]=useState(false);
    const [loadingA,setLoadingA]=useState(false);
    const [dataAgencias,setDataAgencias]=useState(false)
    const getCurrentDateTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    useEffect(()=>{
      buscar_agencia()
    },[])
    const Eliminar=()=>{
      setLoadingM(true)
      const fetchDataPost = async () => {
        
     try {
       const response = await fetch(server.url+'/api/v1/cassia/exception_agencies/'+user.exception_agency_id, {
         method: 'DELETE',  
         headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
         body:JSON.stringify({
           "closed_at":""+getCurrentDateTime()
         })
       });
       if (response.ok) {
         
         const data1 = await response.json();
         setLoadingM(false)
         // Manejo de la respuesta
         setData(data1)
         buscar_cis()
         closDeleteUserModal()
         
         // console.log(data1);
       } else {
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
          // Manejo de errores
          setError(error)
          console.error(error);
        }
      };

      fetchDataPost();
    }
    const [countExptn,setCountExpt]=useState(-1)
    const buscar_agencia=()=>{
      setLoadingA(true)
      const fetchDataPost = async () => {
        
     try {
       const response = await fetch(server.url+'/api/v1/cassia/exceptions/count/0?dispId=0', {
         method: 'GET',  
         headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         }
       
       });
       if (response.ok) {
         const data1 = await response.json();
         setDataAgencias(data1.data)
         const totalexept=data1.data.find((agency) => agency.exception_agency_id === user.exception_agency_id)
         setCountExpt((data1.data.length==0 || totalexept==undefined)?0:data1.data.find((agency) => agency.exception_agency_id === user.exception_agency_id).count)
         setLoadingA(false)
       } else {
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
          // Manejo de errores
          setError(error)
          console.error(error);
        }
      };

      fetchDataPost();
    }
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs delete-modal-gs'>
                            {/* <div className='head-card-modal-gs delete-modal-gs'>
                                <div className='title-head-card-modal-gs'>
                                   ELIMINAR  AGENCIA
                                </div>
                            </div> */}
                            <div className='content-card-modal-gs'>
                                <div className='cont-info-modal-delete-gs'>
                                    {(loadingA)?<div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><LoadSimple></LoadSimple></div>:
                                      (countExptn==0)?
                                    <>
                                    <div className='cont-message-modal-delete-gs'>
                                            <div className='txt-message-modal-delete-gs'>
                                                {lang[languaje]['eliminar']+"  "+lang[languaje]['agencia']}:
                                            </div>
                                    </div>
                                    <div className='cont-user-modal-delete-gs'>
                                    <div style={{border:'2px solid grey',width:'40px',color:'aliceblue',backgroundColor:user.color,height:'40px',borderRadius:'50%',display:"flex",justifyContent:'center',alignItems:'center'}}>
                                              {
                                                (user.img==null)?'N/A':
                                                <img
                                                src={'/iconos/'+user.img}
                                              
                                                name="Editar" title="Editar" className="btnAction delteException" style={{width:'65%'}}
                                              />
                                              }
                                              </div>
                                            <div className='txt-user-modal-delete'>
                                                {user.name}
                                            </div>
                                    </div>
                                    <div className='cont-btn-modal-delete-gs'>
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                <Action  disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['eliminar'])}  action={Eliminar}></Action>
                                            <Action  disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closDeleteUserModal}></Action>
                                                </>
                                            }
                                    </div>
                                    </>:
                                    <>
                                    <div className='cont-message-modal-delete-gs'>
                                            <div className='txt-message-modal-delete-gs'>
                                                {lang[languaje]['noDeleteAgency']}:
                                            </div>
                                    </div>
                                    <div className='cont-user-modal-delete-gs'>
                                    
                                            <div className='txt-user-modal-delete-gs' style={{textAlign:'center',fontSize:'14px',wordBreak:'initial'}}>
                                            {lang[languaje]['noDeleteAgencyDetail']}.
                                            </div>
                                    </div>
                                     <div className='cont-btn-modal-delete-gs' >
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                {/* <Action  disabled={false} origen='Red' titulo='Eliminar'  action={Eliminar}></Action> */}
                                            <Action  disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closDeleteUserModal}></Action>
                                                </>
                                            }
                                    </div>
                                    </>
                                    }
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default ModalDeleteUSer